module.exports = __webpack_public_path__ + "img/service_videoprod.3edcc048.jpg";